/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { getOwnerDocument } from "./getOwnerDocument";

export function getOwnerWindow(node: Node | undefined): Window {
	const doc = getOwnerDocument(node);
	return doc.defaultView || window;
}
